export default __webpack_public_path__ + "static/media/404.dcd49b86.svg";